module.exports = __webpack_public_path__ + "img/bailiffs_security_lowerlayer.aa7ca126.png";